import React, {Component, Fragment} from "react";
import Titre from "../../../components/UI/Titres/TitreH1";
import Button from "react-bootstrap/Button";
import {LinkContainer} from "react-router-bootstrap";
import ContactForm from "./ContactForm/ContactForm";
import {Route} from "react-router-dom";

class Contact extends Component {
    render() {
        return (
            <Fragment>
                <Titre>Contactez-moi !</Titre>
                <div>
                    <h3>Adresse : </h3>
                    <h5>Riadh Nsiri</h5>
                    <h5>5, rue de brueau</h5>
                    <h5>78660 Ablis</h5>
                    <h3>Téléphone : </h3>
                    <h5>06 25 03 93 41</h5>
                    <h3>Vous préfèrez m'écrire ?</h3>
                    <LinkContainer to={this.props.match.path+"/form"}>
                         <Button variant="primary">Formulaire de contact</Button>
                    </LinkContainer>
                    <Route path={this.props.match.path + "/form"} render={(props)=><ContactForm/>}/>
                </div>
            </Fragment>
        );
    }
}
export default Contact;